import React, { memo } from 'react';
import styled from 'styled-components';
import { colors } from 'src/config/colors';
import CloseIcon from 'src/assets/icons/CloseIcon';
import { ZoomBlue } from 'src/common/images/ZoomBlue';
import { Button, CleanButton } from 'src/common/components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { zoomCardClosedSelector } from 'src/state/zoom-card/zoomCardSelectors';
import { isSome } from 'fp-ts/lib/Option';
import { zoomCardActions } from 'src/state/zoom-card/zoomCardActions';
import { StyleProps } from 'src/lib/styleProps';

const Card = styled.div`
  background: ${colors.grey05};
  border-radius: 0.375rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 21.5rem;
  padding: 1.25rem 1.25rem 3.125rem;
  position: relative;
  text-align: center;
  width: 100%;
`;

const CloseButton = styled(CleanButton)`
  position: absolute;
  right: 0.625rem;
  top: 0.625rem;
`;

const Text = styled.div`
  margin-bottom: 2.5rem;
`;

export const ZoomCard = memo<StyleProps>(({ className, style }) => {
  const zoomCardClosed = useSelector(zoomCardClosedSelector);
  const dispatch = useDispatch();

  if (isSome(zoomCardClosed)) {
    return null;
  }

  return (
    <Card className={className} style={style}>
      <CloseButton onClick={() => dispatch(zoomCardActions.close())}>
        <CloseIcon size={20} />
      </CloseButton>
      <ZoomBlue />
      <Text>Szkolenia odbywają się na aplikacji zoom</Text>
      <Button as="a" kind="border" href="https://zoom.us/download#client_4meeting" target="_blank">
        Pobierz aplikację
      </Button>
    </Card>
  );
});
ZoomCard.displayName = 'ZoomCard';
